<template>
  <div class="container text-white">
    <div class="row g-5">
      <div class="col-md-6">
        <div class="map-box rounded overflow-hidden shadow">
          <iframe
            class="w-100 h-100 border-0"
            :src="mapSrc"
            loading="lazy"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>

      <div class="col-md-6">
        <h3 class="mb-3 terminal-title text-primary">
          <i class="fas fa-envelope-open-text me-2"></i> {{ $t('contact.title') }}
        </h3>
        <ul class="list-unstyled mb-4">
          <li class="mb-2">
            <i class="fas fa-map-marker-alt me-2 text-primary"></i>
            {{ $t('contact.address') }}
          </li>
          <li class="mb-2">
            <i class="fas fa-envelope me-2 text-primary"></i>
             contact@rusin.ro
          </li>
          <li class="mb-2">
            <i class="fas fa-phone me-2 text-primary"></i>
            {{ $t('contact.phone') }}
          </li>
        </ul>

        <form @submit.prevent="submitForm" class="animate__animated animate__fadeInUp animate__faster">
          <div class="mb-3">
            <label class="form-label">
              <i class="fas fa-user me-1 text-primary"></i> {{ $t('contact.name') }}
            </label>
            <input type="text" class="form-control custom-input" v-model="name" />
          </div>
          <div class="mb-3">
            <label class="form-label">
              <i class="fas fa-at me-1 text-primary"></i> {{ $t('contact.emailLabel') }}
            </label>
            <input type="email" class="form-control custom-input" v-model="email" />
          </div>
          <div class="mb-3">
            <label class="form-label">
              <i class="fas fa-comment-dots me-1 text-primary"></i> {{ $t('contact.message') }}
            </label>
            <textarea class="form-control custom-input" rows="4" v-model="message" />
          </div>

          <TicTacToeCaptcha v-model="captchaPassed" class="mb-4" />

          <button :disabled="!captchaPassed" type="submit" class="btn btn-outline-primary">
            <i class="fas fa-paper-plane me-1"></i> {{ $t('contact.send') }}
          </button>

          <p v-if="formSent" class="text-success mt-3">
            <i class="fas fa-check-circle me-1"></i> {{ $t('contact.success') }}
          </p>
          <p v-if="formError" class="text-danger mt-3">
            <i class="fas fa-exclamation-triangle me-1"></i> {{ formError }}
          </p>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const mapSrc = "https://maps.google.com/maps?q=Bucuresti&t=&z=13&ie=UTF8&iwloc=&output=embed";
import TicTacToeCaptcha from '@/components/TicTacToeCaptcha.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

console.log('Contact.title:', t('contact.title'))
console.log('Contact.address:', t('contact.address'))
try {
  console.log('contact.email:', t('contact.email'))
} catch (err) {
  console.error('💥 contact.email FAILED:', err)
}

console.log('Contact.phone:', t('contact.phone'))
console.log('Contact.name:', t('contact.name'))
console.log('Contact.emailLabel:', t('contact.emailLabel'))
console.log('Contact.message:', t('contact.message'))
console.log('Contact.send:', t('contact.send'))
console.log('Contact.success:', t('contact.success'))

const name = ref('')
const email = ref('')
const message = ref('')
const captchaPassed = ref(false)
const formSent = ref(false)
const formError = ref(null)

const submitForm = async (e) => {
  e.preventDefault()
  formError.value = null

  try {
    const res = await fetch('https://api.rusin.ro/contact-message/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        name: name.value,
        email: email.value,
        message: message.value
      })
    })

    const data = await res.json()

    if (data.success) {
      formSent.value = true
      name.value = ''
      email.value = ''
      message.value = ''
    } else {
      formError.value = data.error || 'A apărut o eroare.'
    }
  } catch (err) {
    formError.value = err.message || 'Eroare necunoscută.'
  }
}


</script>

<style scoped>
.map-box {
  height: 100%;
  min-height: 300px;
  border: 2px solid #00ffcc;
  background-color: #111;
  box-shadow: 0 0 10px #00ffcc33;
  transition: box-shadow 0.3s ease;
}
.map-box:hover {
  box-shadow: 0 0 20px #00ffcc;
}

.custom-input {
  background-color: #222;
  border: 1px solid #00ffcc;
  color: white;
  font-family: 'Fira Code', monospace;
  transition: all 0.3s ease;
  box-shadow: 0 0 5px transparent;
}

.custom-input:focus {
  border-color: #00ffcc;
  box-shadow: 0 0 8px #00ffccaa;
  background-color: #111;
}

.text-primary {
  color: #00ffcc !important;
}
.btn-outline-primary {
  position: relative;
  color: #00ffcc !important;
  border: 2px solid #00ffcc;
  background-color: transparent;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 0 8px transparent;
}
input.custom-input,
textarea.custom-input {
  color: #fff !important;
}

.btn-outline-primary:hover {
  color: #fff !important;
  background-color: #00ffcc !important;
  border-color: #00ffcc;
  transform: translateY(-2px);
}
.btn-outline-primary:disabled {
  color: #fff !important;
  border-color: #00a584;
  transform: translateY(-2px);
}

</style>
